<template>
  <div v-if="response.user_company_addresses.length">
    <div>
      <b>ข้อมูลขอใบกำกับภาษีที่ AI วิเคราะห์ได้</b>
    </div>
    <div>คุณลูกค้าท่านนี้เคยมีข้อมูลที่อยู่บริษัทสำหรับออกใบกำกับภาษีแล้ว</div>
    <ul class="ai-list">
      <li :key="index" v-for="(userCompanyAddress, index) in response.user_company_addresses">
        <div>
          {{ userCompanyAddress.company }} <span v-if="userCompanyAddress.tax_id">{{ userCompanyAddress.tax_id }}</span>
        </div>
      </li>
    </ul>
    <div>
      คุณสามารถตรวจสอบ และออกใบกำกับภาษีแบบเต็มได้ที่
      <a href="https://admin-test.beneat.co/receipt" target="_blank">https://admin-test.beneat.co/receipt</a>
      <span v-if="response.params.email">โดยใช้อีเมล์ {{ response.params.email }}</span>
    </div>
  </div>
  <div class="text-small" v-else>
    <div>คุณลูกค้าท่านนี้ยังไม่เคยมีข้อมูลที่อยู่บริษัทสำหรับออกใบกำกับภาษี</div>
    <div class="pt-2" v-if="response.user_id">คุณสามารถสร้างที่อยู่บริษัทได้ที่
      <a :href="`https://admin-test.beneat.co/user/${response.user_id}`" target="_blank">
        https://admin-test.beneat.co/user/{{ response.user_id }}
      </a>
      หัวข้อ <b>ที่อยู่บริษัท (สำหรับออกใบกำกับภาษีคุณลูกค้าทั่วไป)</b>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    response: Object
  }
}
</script>
